import React from 'react'
import styles from './PracticeTestCard.module.scss'
import { ShowGatsbyImage } from '../JobTestSticky'

const PracticeTestCard = ({ color, img, count, title, redirectUrl }) => {
  return (
    <div className={`${styles.card} col-md-4 col-sm-6`}>
      <div className={styles.quizImg}>
        <ShowGatsbyImage alt={title} image={img} />
      </div>
      <div className={styles.overlay}>
        <p>{`FREE ${title}`}</p>
      </div>
      <div className="text-center my-4">
        This{' '}
        <a
          href={redirectUrl}
          target={
            redirectUrl.includes('http://') || redirectUrl.includes('http')
              ? '_blank'
              : '_self'
          }
          rel="noreferrer"
        >
          {title}
        </a>{' '}
        has {count} questions (and includes answers and full explanations).
      </div>
      <p className="text-center mb-5">
        <a
          style={{ background: color }}
          className={styles.quizBtn}
          href={redirectUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Take Quiz
        </a>
      </p>
    </div>
  )
}

export default PracticeTestCard
